import {
  AttachMoney,
  Description,
  HomeOutlined,
  Receipt,
  RestorePageOutlined,
} from '@material-ui/icons'
import LazyLoading from 'components/LazyLoading'
import { routeCodes, subRouteCodes } from 'constants/routes'
import { IRouteCodes } from 'interfaces'

const Default = LazyLoading(() => import('./pages/Default'))
const Dashboard = LazyLoading(() => import('./pages/Dashboard'))
const Location = LazyLoading(() => import('components/Location'))
const MyAccount = LazyLoading(() => import('app/Default/pages/MyAccount'))
const MyAccountList = LazyLoading(() => import('app/Default/pages/MyAccount/List'))
const MyAccountChangeMail = LazyLoading(() => import('app/Default/pages/MyAccount/ChangeMail'))
const MyAccountChangePassword = LazyLoading(() =>
  import('app/Default/pages/MyAccount/ChangePassword')
)
const MyAccountChangePhone = LazyLoading(() => import('app/Default/pages/MyAccount/ChangePhone'))
const MyAccountToken = LazyLoading(() => import('app/Default/pages/MyAccount/Token'))
const HireCredit = LazyLoading(() => import('./pages/HireCredit'))
const Simulate = LazyLoading(() => import('./pages/HireCredit/Simulate'))
const ProposalStatus = LazyLoading(() => import('./pages/HireCredit/ProposalStatus'))
const UpdateDataForm = LazyLoading(() => import('./pages/UpdateData/Form'))
const Resume = LazyLoading(() => import('./pages/HireCredit/Resume'))
const Contracts = LazyLoading(() => import('./pages/Contracts'))
const ContractsList = LazyLoading(() => import('./pages/Contracts/List'))
const ContractsView = LazyLoading(() => import('./pages/Contracts/View'))
const Proposals = LazyLoading(() => import('./pages/Proposals'))
const ProposalsList = LazyLoading(() => import('./pages/Proposals/List'))
const ProposalsView = LazyLoading(() => import('./pages/Proposals/View'))
const Renegotiate = LazyLoading(() => import('./pages/Renegotiate'))
const RenegotiateList = LazyLoading(() => import('./pages/Renegotiate/List'))
const RenegotiateSimulate = LazyLoading(() => import('./pages/Renegotiate/Simulate'))
const RenegotiateResume = LazyLoading(() => import('./pages/Renegotiate/Resume'))

export const WorkerRoutes: IRouteCodes = {
  DEFAULT: {
    path: routeCodes.NULL_ROUTE,
    name: 'Página inicial',
    component: Default,
    hideInSidePanel: true,
  },
  DASHBOARD: {
    path: routeCodes.WORKER.DASHBOARD,
    name: 'Página Inicial',
    component: Dashboard,
    icon: HomeOutlined,
    defaultRoute: true,
  },
  LOCATION: {
    path: routeCodes.WORKER.LOCATION,
    name: 'Habilitar localização',
    component: Location,
    hideInSidePanel: true,
  },
  MY_ACCOUNT: {
    path: routeCodes.WORKER.MY_ACCOUNT,
    name: 'Minha Conta',
    component: MyAccount,
    hideInSidePanel: true,
    routes: {
      DEFAULT: {
        path: routeCodes.NULL_ROUTE,
        name: 'Minha Conta',
        component: MyAccountList,
      },
      CHANGE_MAIL: {
        path: subRouteCodes.WORKER.MY_ACCOUNT.CHANGE_MAIL,
        name: 'Alterar Email',
        component: MyAccountChangeMail,
      },
      CHANGE_PASSWORD: {
        path: subRouteCodes.WORKER.MY_ACCOUNT.CHANGE_PASSWORD,
        name: 'Alterar Senha',
        component: MyAccountChangePassword,
      },
      CHANGE_TELEPHONE: {
        path: subRouteCodes.WORKER.MY_ACCOUNT.CHANGE_PHONE,
        name: 'Alterar Telefone',
        component: MyAccountChangePhone,
      },
      TOKEN: {
        path: subRouteCodes.WORKER.MY_ACCOUNT.TOKEN,
        name: 'Confirmar código',
        component: MyAccountToken,
      },
    },
  },
  HIRE_CREDIT: {
    path: routeCodes.WORKER.HIRE_CREDIT,
    name: 'Contratar Crédito',
    icon: AttachMoney,
    component: HireCredit,
    routes: {
      DEFAULT: {
        path: routeCodes.NULL_ROUTE,
        name: 'Simulação de crédito',
        component: Simulate,
      },
      CONFIRM_DATA: {
        path: subRouteCodes.WORKER.HIRE_CREDIT.CONFIRM_DATA,
        name: 'Atualizar dados',
        component: UpdateDataForm,
      },
      RESUME: {
        path: subRouteCodes.WORKER.HIRE_CREDIT.RESUME,
        name: 'Resumo',
        component: Resume,
      },
      PROPOSAL_STATUS: {
        path: subRouteCodes.WORKER.HIRE_CREDIT.STATUS,
        name: 'Andamento da Proposta',
        component: ProposalStatus,
      },
    },
  },
  RENEGOTIATE: {
    path: routeCodes.WORKER.RENEGOTIATE,
    name: 'Renegociar Crédito',
    icon: RestorePageOutlined,
    component: Renegotiate,
    routes: {
      DEFAULT: {
        path: routeCodes.NULL_ROUTE,
        name: 'Renegociar Crédito',
        component: RenegotiateList,
      },
      SIMULATE: {
        path: subRouteCodes.WORKER.RENEGOTIATE.SIMULATE,
        name: 'Renegociar Crédito',
        component: RenegotiateSimulate,
      },
      CONFIRM_DATA: {
        path: subRouteCodes.WORKER.RENEGOTIATE.CONFIRM_DATA,
        name: 'Atualizar dados',
        component: UpdateDataForm,
      },
      RESUME: {
        path: subRouteCodes.WORKER.RENEGOTIATE.RESUME,
        name: 'Resumo',
        component: RenegotiateResume,
      },
    },
  },
  PROPOSALS: {
    path: routeCodes.WORKER.PROPOSALS,
    name: 'Propostas',
    icon: Description,
    component: Proposals,
    routes: {
      DEFAULT: {
        path: routeCodes.NULL_ROUTE,
        name: 'Consultar dados',
        component: ProposalsList,
      },
      VIEW: {
        path: '/:id',
        name: 'Visualizar Contrato',
        component: ProposalsView,
      },
      ANALYSIS: {
        path: '/analysis',
        name: 'Consultar dados',
        component: ProposalsList,
      },
      DENIED: {
        path: '/denied',
        name: 'Consultar dados',
        component: ProposalsList,
      },
    },
  },
  CONTRACTS: {
    path: routeCodes.WORKER.CONTRACTS,
    name: 'Contratos',
    icon: Receipt,
    component: Contracts,
    routes: {
      DEFAULT: {
        path: routeCodes.NULL_ROUTE,
        name: 'Consultar dados',
        component: ContractsList,
      },
      VIEW: {
        path: '/:id',
        name: 'Visualizar Contrato',
        component: ContractsView,
      },
      ANALYSIS: {
        path: '/analysis',
        name: 'Consultar dados',
        component: ContractsList,
      },
      DENIED: {
        path: '/denied',
        name: 'Consultar dados',
        component: ContractsList,
      },
      REVERSED: {
        path: '/reversed',
        name: 'Consultar dados',
        component: ContractsList,
      },
      FINISHED: {
        path: '/finished',
        name: 'Consultar dados',
        component: ContractsList,
      },
      PENDIDNG: {
        path: '/pending',
        name: 'Consultar dados',
        component: ContractsList,
      },
    },
  },
}

export default WorkerRoutes
